import React from 'react';
import { Badge, Text } from '@shopify/polaris';

/** Up to 8 users then up to 8 mention contacts (2026-10-21), each as {kind:'u'|'c', id, name, sub, badge}. */
export function filteredItems(users, contacts, query) {
    const q = (query || '').toLowerCase();
    const hit = x => !q || String(x.name || '').toLowerCase().includes(q);
    const us = (users || []).filter(hit).slice(0, 8).map(u => ({
        kind: 'u', id: u.user_id, name: u.name, badge: !!u.shopify_linked,
        sub: `${u.role_label || ''}${u.location_label ? ` · ${u.location_label}` : ''}`,
    }));
    const cs = (contacts || []).filter(hit).slice(0, 8).map(c => ({
        kind: 'c', id: c.contact_id, name: c.name, sub: c.group_label || 'Contact', badge: true,
    }));
    return [...us, ...cs];
}

export function filteredUsers(users, query) { return filteredItems(users, [], query); }

const initials = (name) => String(name || '').split(' ').map(s => s[0]).join('').slice(0, 2).toUpperCase();

export default function MentionPopover({ items, unavailable, activeIndex, onPick }) {
    const list = items || [];
    const note = unavailable
        ? `Store and production contacts need ${/session/i.test(unavailable) ? 'a live Shopify session' : 'your Shopify link'}`
        : null;
    if (!list.length && !note) return null;
    const firstContact = list.findIndex(i => i.kind === 'c');
    return (
        <div className="cm-popover" role="listbox">
            {list.map((u, i) => (
                <React.Fragment key={`${u.kind}${u.id}`}>
                    {i === firstContact && <div className="cm-popover__divider">Store and production contacts</div>}
                    <div role="option" aria-selected={i === activeIndex}
                         className={`cm-popover__row${i === activeIndex ? ' cm-popover__row--active' : ''}`}
                         onMouseDown={(e) => { e.preventDefault(); onPick(u); }}>
                        <span className={`cm-avatar${u.kind === 'c' ? ' cm-avatar--contact' : ''}`} aria-hidden>{initials(u.name)}</span>
                        <span className="cm-popover__name">{u.name}</span>
                        <Text as="span" tone="subdued" variant="bodySm">{u.sub}</Text>
                        {u.badge && <Badge tone="success" size="small">Shopify</Badge>}
                    </div>
                </React.Fragment>
            ))}
            {note && <div className="cm-popover__note">{note}</div>}
        </div>
    );
}
